module.exports = __webpack_public_path__ + "static/media/RedknotHQ.e77ff862.png";